/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiMarkerModel } from '../../models/api-marker-model';

export interface GetMarkers$Params {
}

export function getMarkers(http: HttpClient, rootUrl: string, params?: GetMarkers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ApiMarkerModel>>> {
  const rb = new RequestBuilder(rootUrl, getMarkers.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ApiMarkerModel>>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
getMarkers.PATH = '/api/CoilAsync/markers';
getMarkers.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
getMarkers.ROOTURL = '/coil';
